export default function ($translate, $rootScope) {
    const result = {
        KEYS: {
            SELF: 'SELF',
            LEADER: 'LEADER',
            SUBJECT: 'SUBJECT',
            COLLEAGUE: 'COLLEAGUE',
            ELSE: 'ELSE'
        },
        LABELS: {
            SELF: $translate.instant('evaluation.role.Self'),
            LEADER: $translate.instant('evaluation.role.Manager'),
            SUBJECT: $translate.instant('evaluation.role.Subject'),
            COLLEAGUE: $translate.instant('evaluation.role.Colleague'),
            ELSE: $translate.instant('evaluation.role.Else')
        }
    };
    // TODO: Figure out how to do this correctly or move it to central component that covers all enums
    $rootScope.$on('$translateChangeSuccess', () => {
        result.LABELS = {
            SELF: $translate.instant('evaluation.role.Self'),
            LEADER: $translate.instant('evaluation.role.Manager'),
            SUBJECT: $translate.instant('evaluation.role.Subject'),
            COLLEAGUE: $translate.instant('evaluation.role.Colleague')
        };
    });
    return result;
}



// WEBPACK FOOTER //
// ./src/app/enums/evaluation/role/index.js